const React = require('react')
const { useState, useEffect } = require('react')
const { useHistory } = require('react-router-dom')
const { Table, Row, Col } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')
const { useFormatBytes, useResponsive, BREAKPOINTS } = require('@hooks')

require('@styles/pages/transaction/blobs.transaction.css')

const TransactionBlobs = props => {
    const { loading, data } = props

    const history = useHistory()
    const { network } = useNetworkConfig()
    const formatBytes = useFormatBytes()
    const isMobile = useResponsive(BREAKPOINTS.large)

    const [transactionBlobs, setTransactionBlobs] = useState([])

    useEffect(() => {
        if (!data) return

        const fields = {
            divider: {
                id: 'divider'
            },
            totalBlobSize: {
                id: 'transaction-total-blob-size',
                label: 'Total Blob Size',
                value: `${128 * data.blobVersionedHashes.length} KiB (${data.blobVersionedHashes.length})`
            },
            blobFee: {
                id: 'transaction-blob-fee',
                label: 'Blob Fee',
                value: (
                    <>
                        <span style={{ color: 'var(--grey-color)' }}>Base:</span>
                        &nbsp;0 {network.data.token}&nbsp;
                        <span style={{ color: 'var(--grey-color)' }}>(0 Gwei)</span>
                        &nbsp;
                        <span style={{ color: 'var(--grey-color)' }}>| Max Gas:</span>
                        &nbsp;
                        {(data.maxFeePerBlobGas / 10 ** 18).toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 18
                        })}
                        &nbsp;
                        {network.data.token}
                        <span style={{ color: 'var(--grey-color)' }}>
                            (
                            {(data.maxFeePerBlobGas / 10 ** 9).toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 9
                            })}
                            &nbsp;Gwei)
                        </span>
                    </>
                )
            },
            blobGasPrice: {
                id: 'transaction-blob-gas-price',
                label: 'Blob Gas Price',
                value: `${(data.blobGasPrice / 10 ** 18).toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 18
                })}`
            },
            blobGasUsed: {
                id: 'transaction-blob-gas-used',
                label: 'Blob Gas Used',
                value: `${(data.blobGasUsed / 10 ** 18).toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 18
                })}`
            }
        }

        const txBlobOrder = ['totalBlobSize', 'blobFee', 'blobGasPrice', 'blobGasUsed', 'divider']

        setTransactionBlobs(txBlobOrder.map(key => fields[key]))
    }, [data])

    return (
        <div className='box table-section'>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    {transactionBlobs.map(item => (
                        <Row className='table-info-row' noGutters>
                            {item.id === 'divider' ? (
                                <div className='table-divider' />
                            ) : (
                                <>
                                    <Col xs='4' className='d-flex align-items-center'>
                                        <span className='info-label'>{item.label}:</span>
                                    </Col>
                                    <Col xs='8' className='d-flex align-items-center'>
                                        <span className='info-value'>{item.value}</span>
                                    </Col>
                                </>
                            )}
                        </Row>
                    ))}
                    <Table
                        responsive
                        className='transaction-sub-table mb-0'
                        style={isMobile ? { display: 'block', overflowX: 'auto', whiteSpace: 'nowrap' } : {}}
                    >
                        <thead>
                            <tr>
                                <th>Blob Versioned Hash</th>
                                <th style={{ textAlign: 'center' }}>Commitment</th>
                                <th>Size</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.blobVersionedHashes.map((blob, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className='d-flex align-items-center'>
                                            <span
                                                className={`${network.name}-text-color cursor-pointer`}
                                                onClick={() => history.push(`/${network.name}/blob/${blob}`)}
                                            >
                                                {formatBytes(blob, 30, 10, 9)}
                                            </span>
                                        </div>
                                    </td>
                                    <td style={{ textAlign: 'center' }}>{data.blobCommitments[index]}</td>
                                    <td>128KB</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </>
            )}
        </div>
    )
}

module.exports = { TransactionBlobs }
